import store from '@/store';
import user from '@/components/user';
import i18n from '@/configured/vue-i18n';
import { readStoredLocale } from '@/configured/locale-storage';
import { LANGUAGE_CONFIG } from '@/configured/languages/config';

/**
 * PKP language for Craft site handles, GraphQL `site`, and canonical URL slugs.
 *
 * Vuex `i18n.language` is committed at the **start** of `loadLanguage` (before translations load).
 * Prefer **session UI** over API `preferredLanguage` when they disagree (e.g. French chosen on the
 * login form while the account still has English — login does not POST language to Craft).
 */
export function resolveActivePkLanguage() {
  const stored = readStoredLocale();
  if (stored && LANGUAGE_CONFIG[stored]) {
    return stored;
  }

  const vuexLang = store.state.i18n.language || 'en';
  const i18nLoc = i18n.i18n.locale;

  // Vuex updates at the start of loadLanguage; vue-i18n.locale updates at the end. Prefer Vuex so
  // GraphQL site / slug match the session between those two moments.
  let live = null;
  if (LANGUAGE_CONFIG[vuexLang]) {
    live = vuexLang;
  } else if (i18nLoc && LANGUAGE_CONFIG[i18nLoc]) {
    live = i18nLoc;
  }

  const currentUser = store.state[user.store.namespace].currentUser;
  const prefRaw =
    currentUser &&
    currentUser.preferredLanguage &&
    String(currentUser.preferredLanguage).trim();
  const pref =
    prefRaw && LANGUAGE_CONFIG[prefRaw] ? prefRaw : null;

  if (live && pref && live !== pref) {
    // Account prefers a locale but Vuex/i18n not updated yet (before loadLanguage commits).
    if (live === 'en' && pref !== 'en') {
      return pref;
    }
    // User switched UI away from saved preference (login/signup language, unsaved session).
    return live;
  }

  if (live) {
    return live;
  }

  if (pref) {
    return pref;
  }

  return 'en';
}
